// extracted by mini-css-extract-plugin
export var divider = "_vf-0";